import { render } from "./ParentChildrenDataTable.vue?vue&type=template&id=7983fae5&scoped=true"
import script from "./ParentChildrenDataTable.vue?vue&type=script&lang=js"
export * from "./ParentChildrenDataTable.vue?vue&type=script&lang=js"

import "./ParentChildrenDataTable.vue?vue&type=style&index=0&id=7983fae5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7983fae5"]])

export default __exports__